import React, { ReactElement } from 'react';
import emptyStateHero from 'assets/empty_state_hero.webp';
import { useTranslation } from 'react-i18next';

type ErrorViewProps = {
  errorMessage?: string | any;
  errorDetails?: string | ReactElement<any, any> | any;
  styles?: { paddingTop?: string | HTMLElement; imageWidth?: string };
  paddingTop?: string;
};
const ErrorView = ({ errorMessage, errorDetails, styles }: ErrorViewProps) => {
  const { t } = useTranslation();
  return (
    <div
      data-cy="error_view"
      data-testid="error_view"
      className={`flex flex-col h-screen justify-start items-center pt-${
        styles?.paddingTop ?? '12em'
      }`}
    >
      <img
        src={emptyStateHero}
        className={`block mx-auto w-${styles?.imageWidth ?? '50%'} mb-24`}
        alt=""
      />
      <div
        data-cy="error_view_message"
        data-testid="error_view_message"
        className="text-16 text-center font-semibold mb-8"
      >
        {t(errorMessage ?? 'Something went wrong.')}
      </div>
      <div
        data-cy="error_view_details"
        data-testid="error_view_details"
        className="text-14 text-center text-gray-subtitle"
      >
        {errorDetails}
      </div>
    </div>
  );
};

export default ErrorView;
